import React, { useEffect } from 'react';
import cheerio from 'cheerio';
import { Select, SelectOption } from 'components/ui';

const PrimaryCTALinkSelector = ({ html, ampHtml, value, onChange }) => {
  const links = extractLinks(html || '' + ' ' + ampHtml || '');

  useEffect(() => {
    if (value && (!links || !links.includes(value))) {
      onChange(null);
    }
  }, [value, onChange, links]);

  if (!links?.length) return <div></div>;

  return (
    <div style={{ marginTop: 5, width: '100%' }}>
      <div style={{ marginBottom: 8 }}>
        <h6 className="input-name" style={{ marginBottom: 0 }}>
          Primary CTA Link
        </h6>
      </div>
      <Select style={{ width: '90%' }} value={value} onChange={onChange}>
        <SelectOption key="default" value="">
          Select Primary CTA Link
        </SelectOption>
        {links.map(sendThrough => (
          <SelectOption key={sendThrough} value={sendThrough}>
            {sendThrough}
          </SelectOption>
        ))}
      </Select>
    </div>
  );
};

function extractLinks(html) {
  const $ = cheerio.load(html);
  const links = new Set();

  $('a').each((index, element) => {
    const url = $(element).attr('href');
    if (url && url.startsWith('http')) {
      try {
        const parsedUrl = new URL(url);
        links.add(
          `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}`,
        );
      } catch (e) {}
    }
  });

  return Array.from(links);
}

export default PrimaryCTALinkSelector;
